// Breakpoint table — PSD §8.7 (F8.7). Results screen.

import type { Breakpoint, BreakpointTrancheResult } from '@backsolve/shared-types';
import { usd } from '../../format/format';

interface BreakpointTableProps {
  breakpoints: Breakpoint[];
  allocation: BreakpointTrancheResult[];
}

export function BreakpointTable({ breakpoints, allocation }: BreakpointTableProps) {
  if (breakpoints.length === 0) {
    return <p>No breakpoints generated.</p>;
  }

  return (
    <div className="table-wrap">
      <p className="result-caption">
        Breakpoints are equity values at which the set of classes sharing
        proceeds changes (e.g. a preferred class reaches its cap and converts).
        The solver walks these brackets to allocate total equity value.
      </p>
      <table className="data-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Equity Value Low</th>
            <th>Equity Value High</th>
            <th>Cause</th>
            <th>Call (High)</th>
            <th>Call (Low)</th>
            <th>Tranche Value</th>
            <th>Classes Sharing</th>
          </tr>
        </thead>
        <tbody>
          {breakpoints.map((bp, i) => {
            const tranche = allocation.find((a) => a.breakpointIndex === bp.index);
            return (
              <tr key={i}>
                <td>{bp.index}</td>
                <td>{usd(bp.equityValueLow)}</td>
                <td>{usd(bp.equityValueHigh)}</td>
                <td>{bp.cause}</td>
                <td>{tranche ? usd(tranche.callValueHigh) : '—'}</td>
                <td>{tranche ? usd(tranche.callValueLow) : '—'}</td>
                <td>{tranche ? usd(tranche.trancheValue) : '—'}</td>
                <td style={{ fontSize: 'var(--font-size-1)' }}>
                  {bp.classesSharing.length} class{bp.classesSharing.length !== 1 ? 'es' : ''}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
